/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Profile_Weight_EyebrowInputs */

const en_us2_profile_weight_eyebrow = /** @type {(inputs: Profile_Weight_EyebrowInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Weight · ${i?.date}`)
};

const pt_br2_profile_weight_eyebrow = /** @type {(inputs: Profile_Weight_EyebrowInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Peso · ${i?.date}`)
};

const es_419_profile_weight_eyebrow = /** @type {(inputs: Profile_Weight_EyebrowInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Peso · ${i?.date}`)
};

const pt_pt2_profile_weight_eyebrow = /** @type {(inputs: Profile_Weight_EyebrowInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Peso · ${i?.date}`)
};

const fr_fr2_profile_weight_eyebrow = /** @type {(inputs: Profile_Weight_EyebrowInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Poids · ${i?.date}`)
};

const de_de2_profile_weight_eyebrow = /** @type {(inputs: Profile_Weight_EyebrowInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Gewicht · ${i?.date}`)
};

const it_it2_profile_weight_eyebrow = /** @type {(inputs: Profile_Weight_EyebrowInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Peso · ${i?.date}`)
};

/**
* | output |
* | --- |
* | "Weight · {date}" |
*
* @param {Profile_Weight_EyebrowInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_weight_eyebrow = /** @type {((inputs: Profile_Weight_EyebrowInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Weight_EyebrowInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_weight_eyebrow(inputs)
	if (locale === "es-419") return es_419_profile_weight_eyebrow(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_weight_eyebrow(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_weight_eyebrow(inputs)
	if (locale === "de-DE") return de_de2_profile_weight_eyebrow(inputs)
	if (locale === "it-IT") return it_it2_profile_weight_eyebrow(inputs)
	return en_us2_profile_weight_eyebrow(inputs)
});
export { profile_weight_eyebrow as "profile.weight_eyebrow" }